import React from "react";

const About = () => {
  return (
    <div className="about">
      <h1>WeatherNow｜即時天氣小幫手</h1>
      <h3>用 React 打造，串接氣象局 API，一眼掌握你所在城市的最新天氣資訊</h3>
    </div>
  );
};

export default About;
